import React from 'react';
import { Grid } from '@material-ui/core';

import '../assets/css/effect.css';

import PeTopBar from '../components/PeTopbar';
import PeStep from '../components/PeStep';
import PeDetailInfo from '../components/PeDetailInfo';

import PeDialog from '../components/PeDialog';
import PeSnackBar from '../components/PeSnackBar';
import PeBackdrop from '../components/PeLoading';
import PeCrudDialog from '../components/dialogs';

import SolarForm from './DaikinForm';
import { DaikinFormData } from '../components/formData/DaikinFormData';
import State from '../states/State';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';

import { CgMouse } from 'react-icons/cg';
import useWindowSize, { WindowSize } from '../hooks/WindowSize';
import PeDrawerMenu from '../components/PeDrawerMenu';

import shellSlice from '../states/shell/slice';
import loadingSlice from '../states/loading/slice';

import { peScrollIntoView } from '../helpers/scrollHelper';
import { isValid } from 'redux-form';
import onGenerateQuote from '../thunks/onGenerateQuote';
import useStyles from '../styles/styles';
import onGetDataLead from '../thunks/onGetDataLead';
import onLoadProductData from '../thunks/onLoadProductData';
import onGetNote from '../thunks/onGetNote';
import onGetSMSSignatureTemplate from '../thunks/onGetSMSSignatureTemplate';
import onGetSMSTemplate from '../thunks/onGetSMSTemplate';
import onGetLeadSource from '../thunks/onGetLeadSource';
import { Redirect, useHistory } from 'react-router-dom';
import useToken from '../hooks/UseToken';

type WorkSpaceProps = {
  readonly isValid?: any;
}

const SolarFormWorkspace: React.FC<WorkSpaceProps> = props => {
  const classes = useStyles();
  const mySection = React.createRef<HTMLDivElement>();
  const dispatch = useDispatch();

  const [isNotBottom, setIsNotBottom] = useState(false);
  const [pos, setPos] = useState({top: 0, left: 0, x: 0, y: 0});
  const [moving, setMoving] = useState(false);

  const state = useSelector((state: State) => ({
    shell: state.shell,
  }));
  const { grabToScroll, alertScroll, scrollTarget } = state.shell?.setting;
  const { currentStep, doneStep, steps } = state.shell?.step;

  const handleSubmit = (values: DaikinFormData) => {
    if(props.isValid) {
      // create quote
      dispatch(onGenerateQuote(values));
      // console.log(suiteJson);
    }
  }

  const handleScroll = () => {
    if (mySection.current){
      // Get mySection current value 
      const { scrollTop, scrollHeight, clientHeight } = mySection.current;
      
      // Check scroll directtion
      let scrollDirection = 1; // defalut is 1: down
      if (pos.top > scrollTop) {
        scrollDirection = -1; // set to -1: up
      }

      // Get target section step
      const targetSection = document.querySelector<HTMLInputElement>('#step-' + (currentStep + scrollDirection));
      // Get total height of step
      let totalPrevStepHeight = 0;
      steps.forEach((item: any) => {
        if (item.id >= currentStep) {
          return;
        }
        let tmpSection = document.querySelector<HTMLInputElement>('#step-' + item.id);
        if (tmpSection) totalPrevStepHeight += tmpSection?.offsetHeight;
      });
      // console.log('#step-' + (currentStep + scrollDirection), totalPrevStepHeight, scrollTop + clientHeight / 2);
      if (targetSection) {
        // Check scroll area and dispatch current step to state
        if (scrollDirection > 0 && (scrollTop + clientHeight / 2) > targetSection?.offsetTop) {
          // Increase Step
          dispatch(shellSlice.actions.updateCurrentStep(currentStep + scrollDirection));
          if (doneStep < currentStep) {
            dispatch(shellSlice.actions.updateDoneStep(doneStep + 1));
          }
        }
        else if (scrollDirection < 0 && (scrollTop + clientHeight / 2) < totalPrevStepHeight) {
          // Decrease Step
          dispatch(shellSlice.actions.updateCurrentStep(currentStep + scrollDirection));
        }
      }

      // Set isBottom
      if (scrollTop + clientHeight < scrollHeight - 100) {
        setIsNotBottom(true);
      } else {
        setIsNotBottom(false);
      }

      // Set pos
      setPos({
        // The current scroll 
        left: mySection.current.scrollLeft,
        top: mySection.current.scrollTop,
        // Get the current mouse position
        x: 0,
        y: 0,
      });
    }
  }

  const handleMouseDown = (event: any) => {
    if (mySection.current && grabToScroll){
      setPos({
        // The current scroll 
        left: mySection.current.scrollLeft,
        top: mySection.current.scrollTop,
        // Get the current mouse position
        x: event.clientX,
        y: event.clientY,
      });
      setMoving(true);
      // Change the cursor and prevent user from selecting the text
      mySection.current.style.cursor = 'grabbing';
      mySection.current.style.userSelect = 'none';
    }
  }

  const handleMouseUp = (event: any) => {
    if (mySection.current && grabToScroll){
      setMoving(false);
      mySection.current.style.cursor = 'default';
      mySection.current.style.removeProperty('user-select');
    }
  }

  const handleMouseMove = (event: any) => {
    // How far the mouse has been moved
    const dx = event.clientX - pos.x;
    const dy = event.clientY - pos.y;

    // Scroll the element
    if (mySection.current && moving){
      mySection.current.scrollTop = pos.top - dy;
      mySection.current.scrollLeft = pos.left - dx;
    }
  };

  const handleBottomClick = () => {
    // Scroll to bottom
    let formSection = document.querySelector<HTMLInputElement>('#myForm');
    if (formSection){
      formSection.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }

  const size: WindowSize = useWindowSize();
  React.useEffect(() => {
    if(size.width && 0 < size.width && size.width < 1290){
      dispatch(shellSlice.actions.updateLayout(2));
      dispatch(shellSlice.actions.updateAutoScroll(true));
    } else {
      dispatch(shellSlice.actions.updateLayout(0));
    }// eslint-disable-next-line
  }, [size]);

  React.useEffect(() => {
    // get scroll target
    if (scrollTarget) {
      const allNodes = document.querySelectorAll('[id*="node_"]');
      let index = 0;
      allNodes && allNodes.forEach((el: any, key: number) => {
        if (el.getAttribute("id") === "node_".concat(scrollTarget)) {
          index = key;
        }
      });
      if (index && allNodes.item(index + 1)) {
        setTimeout(() => {
          peScrollIntoView("#" + allNodes.item(index + 1).getAttribute("id"), 'center');
        }, 200);
        // reset target
        dispatch(shellSlice.actions.updateScrollTarget(''));
      }
    }
    // Get error notification
    const errorNotifs = document.querySelectorAll<HTMLInputElement>('div.MuiFormHelperText-root.Mui-error');
    // Update shell error list
    errorNotifs && dispatch(shellSlice.actions.updateErrorNotifs(errorNotifs.length));
    // eslint-disable-next-line
  }, [scrollTarget, props.isValid]);

  const isLayout = state.shell.layout;

  // Loading delay
  const isLoaded = state.shell?.productData?.isLoaded;
  React.useEffect(()=> {
    // hide loading
    if (Boolean(isLoaded)) {
      dispatch(loadingSlice.actions.updateLoading({isOpen: false, message: ''}));
    } // eslint-disable-next-line
  }, [isLoaded]);

  // Lead id
  const history = useHistory();
  const leadId = new URLSearchParams(history.location.search).get('leadId');
  React.useEffect(() => {
    if (leadId && leadId !== state.shell?.leadId) {
      dispatch(onGetDataLead(leadId));     
    } // eslint-disable-next-line
  }, [leadId]);

  // Master mode
  const [isRedirect, setRedirect] = React.useState(false);
  const callBack = `/login?callback=${history.location.pathname}${history.location.search}`;
  const { token } = useToken();

  React.useEffect(() => {
    // Check token
    if (token) {
      dispatch(shellSlice.actions.updateIsAuth(true));
      // dispatch(shellSlice.actions.updateInitialValues({
      //   first_solar: 'yes',
      //   roof_pitch: '0 - 25 Degrees',
      //   many_storeys: 'Single Storey',
      //   many_phases: 'Single Phase',
      //   meter_type: 'Smart Meter',
      //   main_switch: '63A',
      //   distance_inverter_to_switch: '2',
      //   external_or_internal: 'External',
      // }));
    }
  }, [token, dispatch]);

  React.useEffect(() => {
    let checkMaster = false;
    // Check master redirect
    if (history.location.pathname.indexOf('/master') !== -1 && !token) {
      checkMaster = true;
      setRedirect(checkMaster);
    }
    if (!Boolean(checkMaster)) {
      dispatch(onLoadProductData());
      dispatch(onGetSMSTemplate());
      dispatch(onGetSMSSignatureTemplate());
      dispatch(onGetNote());
      dispatch(onGetLeadSource());
    } // eslint-disable-next-line
  }, [history, token]);

  return (isRedirect ? <Redirect to={callBack} /> : <>
    {/* Common component */}
    <PeDialog />
    <PeSnackBar />
    <PeBackdrop />
    <PeCrudDialog />
    {isLoaded && <div className={classes.SandenFormWorkspace_app}>
        <PeDrawerMenu />
        <PeTopBar />
        <main className={classes.main}>
          <Grid container spacing={3}>
            {isLayout === 0 &&
            <Grid item xs sm md lg xl className={classes.SandenFormWorkspace_left}>
                <PeStep />
                {/* <DevTab /> */}
              </Grid>
            }
            <Grid item xs={12} sm={12} md={12} lg={7} xl={7} className={classes.form} id="mySection"
              ref={mySection} 
              onScroll={handleScroll} 
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}>
              <SolarForm onSubmit={handleSubmit}/>
            </Grid>
            {isLayout === 0 && 
              <Grid item xs sm md lg xl className={classes.right}>
                <PeDetailInfo />
              </Grid>
            }
          </Grid>
        </main>
        {isNotBottom && alertScroll && isLayout === 0 && <div className={classes.isBottom + ' slide-bottom'}>
          <div className={classes.isBottomItem} onClick={handleBottomClick}>
          <CgMouse className={classes.SandenFormWorkspace_icon}/>
            <p style={{padding: '0 5px', margin: 0}}>Scroll down for more</p>
          </div>
        </div> }
    </div>}
    </>
  );
}
export default connect((state) => ({isValid: isValid("daikin-form")(state)}))(SolarFormWorkspace);
